<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined
        min-height="180px"
      >
        <v-row class="pa-4" v-if="!loading" >

          <v-col class="pl-4" cols="12">
            <h2 class="font-weight-regular">Organizadores:</h2>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="6" xs="12" v-for="(speaker) in edition_organizers" :key="speaker.id">
            - {{ speaker.lastname.toUpperCase() + ', ' +speaker.name }}
          </v-col>
          
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'editionOrganizers', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'showEditionOrganizers',

    data: () => ({
      loading:true,

      edition_organizers:[],

      edition_id: null,
      types_sponsor_id: null,
      sponsor_id: null,
    }),

    methods:{
      async getSpeakersEdition(){
        await axios.get('admin/editions/'+this.edition_id+'/edition-organizers/all').then(response =>{
          this.edition_organizers = response.data.data.edition_organizers
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id
      this.getSpeakersEdition()
    },
  }
</script>
